import json from './online.json'
export const img = json.img
